/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useReducer, useRef } from "react";
import { Modal, ModalBody, Form, Label, Input, Tooltip } from "reactstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";

import { routeNameValidation } from "../../Shared/validation";
import { createRoute } from "../../services/myRoute.service";

import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import "../../pages/MyRoutes/myroutes.scss";
import moment from "moment";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import edit_icon from "../../assets/edit_pencil.svg";
import newRoute_icon from "../../assets/new_route_icon.svg";
import calender_icon from "../../assets/calende-icon.svg";

import { AiFillCaretDown } from "react-icons/ai";

function CreateNewRouteModal({
  route,
  fetchUserRoutes,
  showCreateRouteModal,
  setShowCreateRouteModal,
  pointName,
  setPointName,
  setRouteName,
  setShowListModal,
  pointId,
}) {
  const [startDate, setStartDate] = useState(null);
  const [showClear, setShowClear] = useState("none");
  const [showClearDate, setShowClearDate] = useState("none");
  const [showClearStartingPoint, setShowClearStartingPoint] = useState("none");
  const [showClearCity, setShowClearCity] = useState("none");
  const [errors, setErrors] = useState({});
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [values, setValues] = useState({
    routeName: "",
  });

  console.log(
    showClear,
    showClearDate,
    showClearStartingPoint,
    showClearCity,
    errors,
  );

  const IdentityId = useSelector((state) => state?.userDetailReducer?.userData);
  const isUserLoggedIn = localStorage.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    if (pointName?.title === undefined || pointName?.title === "") {
      setShowClearStartingPoint("none");
    } else {
      setShowClearStartingPoint("block");
    }
  }, [pointName?.title]);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  const toggleCreateRoute = () => {
    setShowCreateRouteModal(!showCreateRouteModal);
    setValues({
      routeName: "",
    });
    setPointName({
      title: "",
    });
    setRouteName("");
    setStartDate(null);
    setShowClearStartingPoint("none");
    setShowClear("none");
    setShowClearDate("none");
  };

  const handleRouteName = (e) => {
    setValues({
      ...values,
      [e?.target?.id]: e?.target?.value?.replace(/^\s+/, ""),
    });
    setErrors({
      [e?.target?.id]: null,
    });
    if (values?.routeName === "") {
      setShowClear("none");
    } else {
      setShowClear("block");
    }
  };

  const clearStartDate = () => {
    setStartDate(null);
    setShowClearDate("none");
  };

  const datepickerRef = useRef(null);
  const handleDateClick = () => {
    if (datepickerRef.current) {
      datepickerRef.current.setFocus();
      datepickerRef.current?.setOpen(true);
    }
  };
  const handleDate = (e) => {
    setStartDate(e);
    if (e === null) {
      setShowClearDate("none");
    } else {
      setShowClearDate("block");
      datepickerRef.current?.setOpen(false);
    }
  };

  const clearRouteName = () => {
    setValues({
      routeName: "",
    });
    setShowClear("none");
  };

  const clearStartingPoint = () => {
    setPointName({
      id: "",
      title: "",
      cityY: "",
    });
    setShowClearStartingPoint("none");
  };

  const clearCity = () => {
    setShowClearCity("none");
  };

  const handleStartPoint = () => {
    setShowListModal(true);
  };

  const handleDateChangeRaw = (e) => {
    e.preventDefault();
  };

  const submitCreateNewRoute = async (e) => {
    e.preventDefault();

    if (!values?.routeName) {
      console.log("values", pointName, values);
      return toast.error("Please enter route name", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
    }

    const errorsx = await routeNameValidation(values);
    setErrors(errorsx);
    if (!errorsx) {
      if (isUserLoggedIn) {
        try {
          // 3/18/'24 fix for mix class type
          // let pointId = pointName?.id || pointName?.mkmID || 0
          console.log("user name1.........", IdentityId?.userName);
          console.log("user name2.........", typeof startDate);
          console.log("user name3.........", pointName?.id ? pointName?.id : 0);
          const response = await createRoute(
            {
              RouteName: values?.routeName?.replace(/\s*$/, ""),
              RouteStartingDate: startDate,
              userRouteDetail: [
                {
                  mkmID: pointId || pointName?.id,
                  orderNumber: 0,
                  visited: false,
                },
              ],
            },
            {
              userName: IdentityId?.userName,
            },
          );
          if (
            response &&
            response?.status === 200 &&
            response?.data?.error === false
          ) {
            toast.success("Route Created Successful!", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });
          } else if (response?.data?.error === true) {
            toast.error(`${response?.data?.errorDescription}`, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            },
          );
        }
      } else {
        setShowCreateRouteModal(false);
        const notLoggedIn = await swal({
          title: "Please Continue to Log In",
          text: "You want to create a new route ?",
          icon: "warning",
          buttons: ["Cancel", "Log In"],
        });
        if (notLoggedIn) {
          navigate("/sign-in");
        }
      }

      setShowCreateRouteModal(false);
      route && fetchUserRoutes();
      setValues({
        routeName: "",
      });
      setPointName({
        title: "",
      });
      setRouteName("");
      setStartDate(null);
      setShowClearStartingPoint("none");

      setShowClear("none");
      setShowClearDate("none");
    }
  };

  return (
    <div>
      <Modal
        className="addnew_route modal-dialog-centered"
        isOpen={showCreateRouteModal}
        toggle={toggleCreateRoute}
      >
        {/* <div > */}
        <div className="nt-modal_header" toggle={toggleCreateRoute}>
          <img src={edit_icon} alt="placeholder" />
          <p>Add New Route</p>
        </div>
        {/* <p>Make a new route</p> */}
        {/* </div> */}
        <ModalBody>
          <Form className="add_route_form" onSubmit={submitCreateNewRoute}>
            <div className="nt-newRouteName">
              <div className="nt-form_lab">
                {/* <Label>Route Name</Label> */}
                <label className="nt-form-city">Route Name: </label>

                {/* <button
                  className="clear-btn"
                  type="button"
                  onClick={clearRouteName}
                  style={{ display: showClear }}
                >
                  clear
                </button> */}
              </div>
              <div className="nt-route-name">
                <Input
                  type="text"
                  autoComplete="off"
                  name="routeName"
                  id="routeName"
                  value={values?.routeName}
                  onChange={handleRouteName}
                  maxLength="100"
                  placeholder="Route Name "
                  className="custom-placeholder"
                />

                <span className="error">
                  {/* {errors?.routeName && errors?.routeName} */}
                </span>
              </div>
            </div>

            <div className="nt-startpoint_nd_date">
              <div className="nt-form_group">
                <div className="nt-form_lab">
                  <label className="nt-form_start">Start Point:</label>
                  {/* <button
                    className="clear-btn"
                    type="button"
                    style={{ display: showClearStartingPoint }}
                    onClick={clearStartingPoint}
                  >
                    clear
                  </button> */}
                </div>
                <div className="nt-start_input" onClick={handleStartPoint}>
                  <button
                    className="nt-add_start_point"
                    defaultValue={pointName?.title + "," + pointName?.cityY}
                    type="button"
                  >
                    {pointName?.title && pointName.cityY ? (
                      <span className="point_value">
                        {pointName?.title + "," + pointName?.cityY}
                      </span>
                    ) : (
                      <span className="nt-point_placeholder">Start Point</span>
                    )}
                  </button>

                  <div className="nt-arrow" to="#">
                    <AiFillCaretDown size={10} />
                  </div>
                </div>
              </div>

              <div className="nt-form_group">
                <div className="nt-form_lab">
                  <Label>Start Date:</Label>
                  {/* <button
                    className="clear-btn"
                    type="button"
                    onClick={clearStartDate}
                    style={{ display: showClearDate }}
                  >
                    clear
                  </button> */}
                </div>
                <div className="nt-start-date">
                  <DatePicker
                    id="TooltipStartDate"
                    selected={startDate}
                    onChange={handleDate}
                    minDate={new Date()}
                    dateFormat="dd/MM/yyyy"
                    onChangeRaw={handleDateChangeRaw}
                    showDisabledMonthNavigation
                    className="custom_date"
                    placeholderText="Start Date"
                    autoComplete="off"
                    ref={datepickerRef}
                    shouldCloseOnSelect={true}
                  />

                  <img
                    src={calender_icon}
                    alt="calendar icon"
                    onClick={handleDateClick} // <- only on icon, not whole div
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>
            </div>

            {/* <FormGroup>
              <div className='form_lab'>
                <Label >Point City</Label>
                <button
                  className='clear-btn'
                  type="button"
                  style={{ display: showClearCity }}
                  onClick={clearCity}
                >
                  clear
                </button>
              </div>
              <Button className='add_start_point' defaultValue={pointName?.title} disabled >
                {pointName?.title ? <span className='point_value'>{pointName?.title}</span> : <span className='point_placeholder'>Point City</span>}
              </Button>
              {/* <Input
                type="text"
                defaultValue={pointName?.title}
                onClick={handleStartPoint}
                autoComplete="off"
                placeholder='Start Point'
              /> */}
            {/* </FormGroup> */}
            <button className="btn-create-new-route" type="submit">
              <img src={newRoute_icon} alt="placeholder" />
              <p>Create a New Route</p>
            </button>
          </Form>
        </ModalBody>
      </Modal>
      {startDate && (
        <Tooltip
          placement="top"
          isOpen={tooltipOpen}
          autohide={false}
          target="TooltipStartDate"
          toggle={toggle}
        >
          {`${moment(startDate).format("DD/MM/YYYY")}`}
        </Tooltip>
      )}
    </div>
  );
}

export default CreateNewRouteModal;
